import { 
  LayoutDashboard, FileText, Plus, Activity, X, TrendingUp, Users, Settings, 
  BarChart3, Package, Receipt, ChevronLeft, ChevronRight, ChevronDown, Shield, 
  Award, Briefcase, Search, ShoppingCart, ClipboardList, ScrollText, 
  FileSignature, Send, Building, ShieldCheck, UserCheck, Lock, Globe, Zap, 
  Key, Banknote, ShieldAlert, Cpu, Network, PieChart, PenTool, Database, 
  HardDrive, CreditCard, GitPullRequest, Calculator, HelpCircle, FileSearch, 
  CheckSquare, FileBox, MessageSquare, CheckCircle, Store, Box, Building2, Brain, Sparkles, Truck, DollarSign, FileBarChart, Layers
} from 'lucide-react';

export const superAdminNavigation = [
  { 
    name: 'Control Tower', 
    headerTitle: 'Platform Control Tower', 
    href: '/superadmin/control-tower', 
    icon: LayoutDashboard, 
    category: 'main', 
    module: 'platform', 
    fullWidth: true,
    children: [
      { name: 'Executive Overview', href: '/superadmin/control-tower', icon: LayoutDashboard, description: 'Real-time System Vitals & KPIs' },
      { name: 'Support & Tenant Switcher', href: '/superadmin/control-tower', icon: Building2, description: 'Investigate Tenant Sessions' }
    ]
  },
  { 
    name: 'Tenants & Orgs', 
    headerTitle: 'Client Organizations', 
    href: '/superadmin/clients', 
    icon: Building, 
    category: 'main', 
    module: 'platform', 
    fullWidth: true,
    children: [
      { name: 'Organization Directory', href: '/superadmin/clients', icon: Building, description: 'Active & Provisioned Clients' },
      { name: 'Tenant Management', href: '/superadmin/clients', icon: Users, description: 'Tenant Setup & Node Allotment' }
    ]
  },
  { 
    name: 'Licensing', 
    headerTitle: 'Cryptographic Licensing', 
    href: '/superadmin/licenses', 
    icon: Shield, 
    category: 'main', 
    module: 'platform', 
    fullWidth: true,
    children: [
      { name: 'License Management', href: '/superadmin/licenses', icon: Shield, description: 'Active RSA-4096 Tenant Licenses' },
      { name: 'Generate New License', href: '/superadmin/licenses', icon: Key, description: 'Issue Cryptographic Keys & Modules' }
    ]
  },
  { 
    name: 'Security & Roles', 
    headerTitle: 'Security & Policy Engine', 
    href: '/superadmin/roles', 
    icon: ShieldCheck, 
    category: 'main', 
    module: 'platform', 
    fullWidth: true,
    children: [
      { name: 'Platform Roles & RBAC', href: '/superadmin/roles', icon: ShieldCheck, description: 'SuperAdmin, Client & Staff Roles' },
      { name: 'Permission Matrix', href: '/superadmin/roles', icon: Lock, description: 'Granular Resource Access Policies' }
    ]
  },
  { 
    name: 'Monitoring', 
    headerTitle: 'Platform Telemetry & Health', 
    href: '/superadmin/monitoring', 
    icon: Activity, 
    category: 'main', 
    module: 'platform', 
    fullWidth: true,
    children: [
      { name: 'System Telemetry', href: '/superadmin/monitoring', icon: Activity, description: 'API Latency, Uptime & System Load' },
      { name: 'Server Health & Services', href: '/superadmin/monitoring', icon: HardDrive, description: 'DB Connections & Background Services' }
    ]
  },
  { 
    name: 'AI Governance', 
    headerTitle: 'Savvy AI Governance & Audit Ledger', 
    href: '/superadmin/ai-audit', 
    icon: Brain, 
    category: 'main', 
    module: 'platform', 
    fullWidth: true,
    children: [
      { name: 'AI Audit Ledger', href: '/superadmin/ai-audit', icon: Brain, description: 'Telemetry & Autonomous Action Records' },
      { name: 'Decision Integrity', href: '/superadmin/ai-audit', icon: Sparkles, description: 'AI Audit Verification & Tracing' }
    ]
  },
  { 
    name: 'Audit Trail', 
    headerTitle: 'Immutable Audit Trail', 
    href: '/superadmin/audit', 
    icon: FileText, 
    category: 'main', 
    module: 'platform', 
    fullWidth: true,
    children: [
      { name: 'Immutable Audit Trail', href: '/superadmin/audit', icon: FileText, description: 'Cross-Tenant Tamper-Proof Audit Log' },
      { name: 'Security Event History', href: '/superadmin/audit', icon: ShieldAlert, description: 'Login, 2FA & Exception Events' }
    ]
  },
  { 
    name: 'Settings', 
    headerTitle: 'System Settings', 
    href: '/superadmin/settings', 
    icon: Settings, 
    category: 'main', 
    module: 'platform', 
    fullWidth: true,
    children: [
      { name: 'Platform Settings', href: '/superadmin/settings', icon: Settings, description: 'Global ERP Environment Configuration' },
      { name: 'License Engine & Config', href: '/superadmin/settings', icon: Key, description: 'RSA Keys & Licensing Parameters' }
    ]
  }
];

export const clientNavigation = [
  { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard, category: 'main', module: 'platform' },
  { 
    name: 'Procurement', 
    href: '/buy', 
    icon: ShoppingCart, 
    category: 'main', 
    module: 'procurement',
    children: [
      { name: 'Requisitions', href: '/requisitions', icon: ClipboardList, description: 'Internal Purchase Demands' },
      { name: 'RFQ / Sourcing Events', href: '/rfx', icon: Send, description: 'Competitive Sourcing & Bids' },
      { name: 'Vendor Quotations', href: '/quotations', icon: FileText, description: 'Compare & Award Proposals' },
      { name: 'Purchase Orders', href: '/purchase-orders', icon: FileText, description: 'Active & Historical POs' },
      { name: 'Goods Receipts (GRN)', href: '/order-receipts', icon: Package, description: 'Warehouse Receiving & Inspection' },
      { name: 'Invoices', href: '/invoices', icon: Receipt, description: '3-Way Match Invoices' },
      { name: 'Contracts', href: '/contracts', icon: FileSignature, description: 'Master Vendor Agreements' }
    ]
  },
  { 
    name: 'Finance', 
    href: '/finance', 
    icon: Banknote, 
    category: 'main', 
    module: 'finance',
    children: [
      { name: 'General Ledger', href: '/finance/accounting/general-ledger', icon: FileText, description: 'Chart of Accounts & Journals' },
      { name: 'Accounts Payable', href: '/finance/accounting/accounts-payable', icon: Receipt, description: 'Vendor Invoices & Aging' },
      { name: 'Accounts Receivable', href: '/finance/accounting/accounts-receivable', icon: Receipt, description: 'Customer Invoices & Collections' },
      { name: 'Cash & Banking', href: '/finance/accounting/cash-bank', icon: CreditCard, description: 'Bank Accounts & Reconciliations' },
      { name: 'Disbursements', href: '/finance/accounting/payments', icon: DollarSign, description: 'Outgoing Vendor Payments' },
      { name: 'Tax Compliance', href: '/finance/accounting/tax', icon: Receipt, description: 'Tax Ledgers & Filings' }
    ]
  },
  { 
    name: 'Budget Control', 
    href: '/budget', 
    icon: PieChart, 
    category: 'main', 
    module: 'budget',
    children: [
      { name: 'Planning & Budgets', href: '/budget/planning', icon: BarChart3, description: 'Department Allocations' },
      { name: 'Control Matrix', href: '/budget-control/dashboard', icon: ShieldCheck, description: 'Hard/Soft Enforcement Rules' },
      { name: 'Commitment Register', href: '/budget-control/commitments', icon: FileText, description: 'Encumbrances & Reserves' },
      { name: 'Budget Overrides', href: '/budget-control/overrides', icon: ShieldAlert, description: 'Management Approval Exceptions' }
    ]
  },
  { 
    name: 'Inventory & POS', 
    href: '/inventory', 
    icon: Box, 
    category: 'main', 
    module: 'inventory',
    children: [
      { name: 'Inventory Stock', href: '/inventory', icon: Box, description: 'Real-time Stock Levels & Value' },
      { name: 'POS Terminals & Register', href: '/pos', icon: Store, description: 'Point of Sale Billing Counter' },
      { name: 'Branches & Stores', href: '/pos/branches-stores', icon: Building2, description: 'Multi-Location Store Setup' },
      { name: 'Stock Transfers', href: '/pos/transfers', icon: Truck, description: 'Inter-Branch Stock Movement' }
    ]
  },
  { 
    name: 'Reports & Analytics', 
    href: '/reports', 
    icon: FileBarChart, 
    category: 'main', 
    module: 'platform',
    children: [
      { name: 'Report Hub (All Reports)', href: '/reports', icon: FileBarChart, description: 'Unified Executive & Operational Reporting' },
      { name: 'Financial Statements', href: '/reports/financial/income-statement', icon: Banknote, description: 'P&L, Balance Sheet, Cash Flow' },
      { name: 'Procurement Spend Analytics', href: '/reports/procurement/spend-analysis', icon: ShoppingCart, description: 'Category, Vendor & Savings breakdown' },
      { name: 'Inventory Valuation', href: '/reports/inventory/valuation', icon: Box, description: 'Stock Levels, Slow-Moving & Aging' },
      { name: 'POS & Branch Performance', href: '/reports/sales/branch-performance', icon: Store, description: 'Store-level daily revenue & sales' },
      { name: 'Audit Trail Ledger', href: '/reports/admin/audit-trail', icon: ShieldCheck, description: 'Immutable User Activity Logs' }
    ]
  },
  { 
    name: 'Approvals', 
    href: '/approvals', 
    icon: GitPullRequest, 
    category: 'main', 
    module: 'approval_workflow',
    children: [
      { name: 'Approval Inbox', href: '/approvals/inbox', icon: CheckCircle, description: 'Items Requiring Your Authorization' },
      { name: 'Approval Center', href: '/approvals', icon: GitPullRequest, description: 'All Department Workflow Status' },
      { name: 'Workflow Rules Engine', href: '/approvals/workflows', icon: Network, description: 'Hierarchy & Threshold Policies' }
    ]
  },
  { 
    name: 'AI Intelligence', 
    href: '/ai', 
    icon: Brain, 
    category: 'main', 
    module: 'platform'
  },
  { 
    name: 'Settings', 
    href: '/settings/system', 
    icon: Settings, 
    category: 'main', 
    module: 'platform',
    children: [
      { name: 'User Management & Roles', href: '/settings/system?tab=users', icon: Users, description: 'Personnel, Permissions & Access' },
      { name: 'Company & Org Structure', href: '/settings/business-configuration', icon: Building2, description: 'Departments, Units & Designations' },
      { name: 'System Configuration', href: '/settings/system', icon: Settings, description: 'Currencies, Fiscal Years, Notifications' },
      { name: 'License & Subscription', href: '/settings/license', icon: Key, description: 'Tenant Modules & Node Entitlements' }
    ]
  }
];

export const vendorNavigation = [
  { name: 'Dashboard', href: '/vendor/dashboard', icon: LayoutDashboard, category: 'main', module: 'vendor_portal', fullWidth: true },
  { name: 'Company Profile', href: '/vendor/profile', icon: Building2, category: 'main', module: 'vendor_portal', fullWidth: true },
  { name: 'RFQ / RFx', href: '/vendor/rfx', icon: FileSearch, category: 'main', module: 'vendor_portal', fullWidth: true },
  { name: 'Quotations / Bids', href: '/vendor/bids', icon: FileText, category: 'main', module: 'vendor_portal', fullWidth: true },
  { name: 'Purchase Orders', href: '/vendor-pos', icon: ShoppingCart, category: 'main', module: 'vendor_portal', fullWidth: true },
  { name: 'Deliveries & Shipments', href: '/vendor/shipments', icon: Truck, category: 'main', module: 'vendor_portal', fullWidth: true },
  { name: 'Invoices', href: '/vendor/finance/invoices', icon: Receipt, category: 'main', module: 'vendor_portal', fullWidth: true },
  { name: 'Payment Status', href: '/vendor/finance/payments', icon: DollarSign, category: 'main', module: 'vendor_portal', fullWidth: true },
  { name: 'Reports', href: '/vendor/reports', icon: FileBarChart, category: 'main', module: 'vendor_portal', fullWidth: true },
  { name: 'Support', href: '/vendor/support', icon: HelpCircle, category: 'main', module: 'vendor_portal', fullWidth: true }
];

export const navigation = clientNavigation;
